"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _getDataUri = _interopRequireDefault(require("./getDataUri"));

var _overrides = require("../../../utils/overrides");

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'Avatar');

function Avatar(_ref) {
  var classesProp = _ref.classes,
      overridesProps = _ref.overrides,
      classNameProps = _ref.className,
      size = _ref.size,
      src = _ref.src,
      alt = _ref.alt,
      placeholder = _ref.placeholder,
      props = (0, _objectWithoutProperties2.default)(_ref, ["classes", "overrides", "className", "size", "src", "alt", "placeholder"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp);

  var _useState = (0, _react.useState)(placeholder || src),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      defaultSrc = _useState2[0],
      setDefaultSrc = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isImageLoaded = _useState4[0],
      setIsImageLoaded = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      hadError = _useState6[0],
      setHadError = _useState6[1];

  var initialSrc = (0, _react.useRef)(src).current;
  var rootClassName = (0, _classnames.default)(classes.root, classes[size], classNameProps);
  var override = (0, _overrides.getOverrides)(overridesProps, Avatar.overrides);
  var rootProps = (0, _extends2.default)({}, props, {
    className: rootClassName
  });
  (0, _react.useEffect)(function () {
    if (!isImageLoaded || initialSrc !== src) {
      if (src && !hadError) {
        (0, _getDataUri.default)(src).then(function (dataUri) {
          if (dataUri) setDefaultSrc(dataUri);
          setIsImageLoaded(true);
        }).catch(function () {
          if (placeholder) {
            setDefaultSrc(placeholder);
            setHadError(true);
            setIsImageLoaded(true);
          }
        });
      } else if (placeholder) {
        setDefaultSrc(placeholder);
        setIsImageLoaded(true);
      }
    }
  }, [src, placeholder, initialSrc, defaultSrc, isImageLoaded, hadError]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, rootProps, override.root), /*#__PURE__*/_react.default.createElement("img", {
    src: defaultSrc,
    alt: alt
  }));
}

Avatar.overrides = ['root'];
Avatar.defaultProps = {
  size: 'medium'
};
process.env.NODE_ENV !== "production" ? Avatar.propTypes = {
  src: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  alt: _propTypes.default.string,
  size: _propTypes.default.oneOf(['small', 'medium', 'large', 'big', 'huge'])
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(Avatar);

exports.default = _default;